export enum ContactCardIdsEnum {
  contactHeader = "contactHeader",
  contactMethods = "contactMethods",
  contactRelationships = "contactRelationships",
  contactProfile = "contactProfile",
  prefCons = "prefCons",
  employers = "employers"
}
